$(document).ready(function () {
// 
if (window.location.href.includes("/products") || window.location.href.includes("/pages/lis-vela-v2") || window.location.href.includes("shopvelasleep")) {
    setTimeout(() => {
        
        if($(".bundle-card").length > 2){
            $(".bundle-card").eq(1).trigger("click");
        }else{
            $(".bundle-card").eq(0).trigger("click");
        }
        
    }, 100);
}

$(document).on("click", ".product-form-wrapper button[type='submit'].product-form__submit", function() {
    console.log("ssss");
    let $container = $(this).closest("product-info");
    if (!$container.length) $container = $(document);

    let $selected = $container.find(".bundle-card.selected");
    if ($selected.length && $selected.find("input.add-on:checked").val()) {
        let qty = $selected.find("input.add-on:checked").attr("data-qty");
        $.ajax({
            url: "/cart/add.js",
            type: "POST",
            async:false,
            contentType: "application/json",
            data: JSON.stringify({
                id: $selected.find("input.add-on:checked").val(),
                quantity:qty
            }),
            success: function (response) {
                document.dispatchEvent(new CustomEvent("cart:refresh", {
                    bubbles: true,
                    detail: { open: true }
                }));
            }
        });
    }
})

// 
    let groupedOptions = {};

    function updateBundleSelection(bundle) {

        let option1 = bundle.attr("data-option");
        let allOptions = [];
        let totalPrice=0;
        bundle.find(".options .option-row").each(function () {
            let rowValues = [option1];

            $(this).find("input.option-input").each(function () {
                rowValues.push($(this).val());
            });

            allOptions.push(rowValues);
        });
        console.log("allOptions---",allOptions);
        

        groupedOptions = {};
        $(".product-option-variants").removeClass("selected");

        allOptions.forEach(function (item) {

            let optionName = item.join(" / ");

            $('.product-option-variants[data-option-name="' + optionName + '"]')
                .addClass("selected");
                let priceAttr = $('.product-option-variants[data-option-name="' + optionName + '"]').attr("data-price");
        let price = priceAttr ? parseFloat(priceAttr) : 0;
                totalPrice += price;
            if (groupedOptions[optionName]) {
                groupedOptions[optionName].quantity++;
            } else {
                groupedOptions[optionName] = {
                    optionName: optionName,
                    quantity: 1
                };
            }
        });
    // $(bundle).find(".bundle-header .price .new").text(`$${totalPrice.toFixed(2)}`)
        console.log(groupedOptions);
    }

    // Bundle click
    
    // $(".bundle-card").on("click", function () {
    $(document).on("click", ".bundle-card", function () {
        $(".product-form-wrapper input[name='quantity']").remove()
        $(".bundle-card").removeClass("selected");
        let qty = $(this).attr("data-qty")
        $(this).toggleClass("selected");
        if ($(".bundle-card.selected").length) {
            $(".product-form-wrapper form").append(`<input type="hidden" name="quantity" value="${qty}">`);
        }
        console.log("Bundle click----",qty);
        
        updateBundleSelection($(this));
         let selectedBundle = $(".bundle-card.selected");
    if (selectedBundle.length) {
        updateBundleSelection(selectedBundle);
    }
    });

    let selectedBundle = $(".bundle-card.selected");
    if (selectedBundle.length) {
        updateBundleSelection(selectedBundle);
    }

    // Add-to-cart
    $(document).on("click", "#submit-bundle", function () {
    let $container = $(this).closest("product-info");
    if (!$container.length) $container = $(document);

    let items = [];
    console.log("groupedOptions---",groupedOptions);

    if (Object.keys(groupedOptions).length > 0) {
        $.each(groupedOptions, function (key, value) {
            var variant = $container.find('.product-option-variants[data-option-name="' + value.optionName + '"]');
            if (variant.length) {
                items.push({
                    id: variant.data("variant-id"),
                    quantity: value.quantity
                });
            }
        });
    }else{
          var selected_var = $container.find(".bundle-card.selected").attr("data-option");
          var variant = $container.find('.product-option-variants[data-option-name="' + selected_var + '"]');
          let variantQuanity;
          if(variant.data("quantity") != null){
            variantQuanity = variant.data("quantity");
          }else{
             variantQuanity = 1;
          }
          items.push({
                id: variant.attr("data-variant-id"),
                quantity: variantQuanity
            });
    }

    if($container.find('.bundle-card.selected .add-on').is(":checked")){
        let Addon = $container.find('.bundle-card.selected input.add-on:checked').val();
        items.push({
            id: Number(Addon),
            quantity: $container.find('.bundle-card.selected input.add-on:checked').attr('data-qty')
        });
    }

    console.log("items", items);
    $.ajax({
        url: "/cart/add.js",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify({ items: items }),
        success: function (response) {
            document.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: { open: true }
            }));
        }
    });
 });
});

document.querySelectorAll(".custom-select").forEach(select => {

    const btn = select.querySelector(".select-btn");
    const list = select.querySelector(".select-list");
    const selected = select.querySelector(".selected");
    const hidden = select.querySelector("input[type='hidden']");

    btn.addEventListener("click", function(e) {
        e.stopPropagation();

        document.querySelectorAll(".custom-select").forEach(item => {
            if (item !== select) {
                item.classList.remove("active");
            }
        });

        select.classList.toggle("active");
    });

    list.querySelectorAll("li").forEach(li => {
        li.addEventListener("click", function() {

            selected.innerHTML = li.innerHTML;
            hidden.value = li.dataset.value;

            select.classList.remove("active");

            // Optional: Trigger change event
            hidden.dispatchEvent(new Event("change"));
        });
    });

});

document.addEventListener("click", function() {
    document.querySelectorAll(".custom-select").forEach(select => {
        select.classList.remove("active");
    });
});
// for quick view variant auto select
(function () {
    function autoSelectBundle($container) {
        let cards = $container.find(".bundle-card");
        if (!cards.length) return;
        if (cards.length > 2) {
            cards.eq(1).trigger("click");
        } else {
            cards.eq(0).trigger("click");
        }
    }

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;

                let $node = $(node);
                let $bundleCards = $node.hasClass("bundle-card") ? $node : $node.find(".bundle-card");

                if ($bundleCards.length) {
                    let $container = $node.is("product-info") ? $node : $node.closest("product-info");
                    if (!$container.length) $container = $node;

                    if (!$container.find(".bundle-card.selected").length) {
                        setTimeout(function () {
                            autoSelectBundle($container);
                        }, 100);
                    }
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();

// end quick view
document.addEventListener("DOMContentLoaded", () => {
  const reviewCount = document.querySelector(".custom-reviews-jtpl")?.dataset.reviews;
  if (!reviewCount) return;

  const observer = new MutationObserver(() => {
    const count = document.querySelector(".oke-w-reviews-controls .oke-w-reviews-count");
    if (count && count.textContent !== reviewCount) {
      count.textContent = reviewCount;
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  // Stop after 5 seconds
  setTimeout(() => observer.disconnect(), 5000);

  
});

document.addEventListener("DOMContentLoaded", function () {
  const reviewTrigger = document.querySelector(".custom-reviews-jtpl");

  if (!reviewTrigger) return;

  reviewTrigger.addEventListener("click", function (e) {
    e.preventDefault();

    const reviewsSection = document.querySelector(".oke-w-reviewsTab");

    if (reviewsSection) {
      reviewsSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
});


// Update price on variant change JS
(function () {
    'use strict';

    // Prevent duplicate initialization.
    if (window.bundlePriceUpdaterInitialized) return;
    window.bundlePriceUpdaterInitialized = true;

    let updateTimer;

    /**
     * Find the selected bundle.
     */
    function getSelectedBundle() {
        const selected = document.querySelector('.bundle-card.selected');
        return selected;
    }

    /**
     * Get the main bundle prices.
     * Add-on prices are deliberately excluded.
     */
    function getBundlePrices(bundle) {
        if (!bundle) return null;

        const priceContainer = bundle.querySelector(
            '.main-bundle-header .bundle-header .price'
        );

        if (!priceContainer) return null;

        const currentElement = priceContainer.querySelector('.new');
        const compareElement = priceContainer.querySelector('.old');

        if (!currentElement) return null;

        return {
            current: currentElement.textContent.trim(),
            compare: compareElement
                ? compareElement.textContent.trim()
                : ''
        };
    }

    /**
     * Update a single main product price element.
     */
    function updatePriceElement(priceElement, prices) {
        if (!priceElement || !prices) return;

        let currentPrice = priceElement.querySelector('.price__regular');

        if (!currentPrice) {
            currentPrice = document.createElement('span');
            currentPrice.className = 'price__regular whitespace-nowrap';
            priceElement.prepend(currentPrice);
        }

        currentPrice.textContent = prices.current;

        let comparePrice = priceElement.querySelector('.price__sale');

        if (prices.compare) {
            if (!comparePrice) {
                comparePrice = document.createElement('span');
                comparePrice.className =
                    'price__sale inline-flex items-center h-auto relative';
                priceElement.appendChild(comparePrice);
            }

            comparePrice.textContent = prices.compare;
            comparePrice.style.removeProperty('display');

            priceElement.classList.add('price--on-sale');
        } else {
            if (comparePrice) {
                comparePrice.remove();
            }

            priceElement.classList.remove('price--on-sale');
        }
    }

    /**
     * Update the main product price.
     */
    function updateMainPrice() {
        const selectedBundle = getSelectedBundle();

        if (!selectedBundle) return;

        const prices = getBundlePrices(selectedBundle);

        if (!prices || !prices.current) return;

        // Prefer the main product price inside the product information section.
        const priceElements = document.querySelectorAll(
            '.product__price [id^="Price-"] .price, ' +
            '[id^="Price-"] .price'
        );

        priceElements.forEach(function (priceElement) {
            // Do not update prices inside bundle cards, add-ons or recommendations.
            if (
                priceElement.closest('.bundle-card') ||
                priceElement.closest('.addon') ||
                priceElement.closest('product-recommendations') ||
                priceElement.closest('.product-card')
            ) {
                return;
            }

            updatePriceElement(priceElement, prices);
        });
    }

    /**
     * Debounce price updates.
     */
    function scheduleUpdate() {
        clearTimeout(updateTimer);
        updateTimer = setTimeout(updateMainPrice, 100);
    }

    /**
     * Handle bundle clicks.
     */
    document.addEventListener('click', function (event) {
        if (!event.target.closest('.bundle-card')) return;

        // Let the theme update the selected class first.
        setTimeout(updateMainPrice, 50);
        setTimeout(updateMainPrice, 200);
        setTimeout(updateMainPrice, 500);
    });

    /**
     * Watch only relevant class changes and price HTML replacements.
     */
    const observer = new MutationObserver(function (mutations) {
        let shouldUpdate = false;

        for (const mutation of mutations) {
            if (mutation.type === 'attributes') {
                if (
                    mutation.target.matches('.bundle-card') ||
                    mutation.target.closest('.bundle-card')
                ) {
                    shouldUpdate = true;
                    break;
                }
            }

            if (mutation.type === 'childList') {
                const target = mutation.target;

                if (
                    target.nodeType === Node.ELEMENT_NODE &&
                    (
                        target.closest('.bundle-card') ||
                        target.closest('.product__price') ||
                        target.matches('.bundle-card, .product__price') ||
                        target.closest('[id^="Price-"]')
                    )
                ) {
                    shouldUpdate = true;
                    break;
                }
            }
        }

        if (shouldUpdate) scheduleUpdate();
    });

    function startObserver() {
        observer.observe(document.body, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['class']
        });

        scheduleUpdate();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startObserver, {
            once: true
        });
    } else {
        startObserver();
    }
})();